import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { FormControl } from '@angular/forms';

import { EoDatepickerConfig } from '../../form/eo-date-picker/eo-date-picker.model';
import { EoDropdownConfig } from '../../form/eo-dropdown/eo-dropdown.model';
import { EoFormPanelConfig } from '../../form/eo-form-panel/eo-form-panel.model';
import { EoFormComponent } from '../../form/eo-form/eo-form.component';
import {
  EoFormConfig,
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../../form/eo-form/eo-form.config';
import { EoInputConfig } from '../../form/eo-input/eo-input.model';
import { EoMultiselectConfig } from '../../form/eo-multiselect/eo-multiselect.model';
import { EoFormTableService } from './eo-form-table.service';
import { IEoFormTableConfig } from './model/eo-form-table-config.model';
import { IFormField } from './model/form-field.model';

@Component({
  selector: 'eo-form-table',
  templateUrl: './eo-form-table.component.html',
  styleUrls: ['./eo-form-table.component.scss'],
})
export class EoFormTableComponent {
  @ViewChild('eoForm') eoForm?: EoFormComponent;

  formTableService = inject(EoFormTableService);

  private _config?: IEoFormTableConfig;
  @Input() set config(val: IEoFormTableConfig | undefined) {
    this._config = val;
    this.setFormConfig();
  }
  get config(): IEoFormTableConfig | undefined {
    return this._config;
  }

  _submitLoading?: boolean;
  @Input() set submitLoading(val: boolean) {
    this._submitLoading = val;
  }
  get submitLoading(): boolean {
    if (this._submitLoading !== undefined) return this._submitLoading;
    if (typeof this.config?.submitLoading === 'function') {
      const data = this.eoForm?.getFormData();
      return this.config.submitLoading(data);
    }
    return this.config?.submitLoading === true || false;
  }

  _deleteLoading?: boolean;
  @Input() set deleteLoading(val: boolean) {
    this._deleteLoading = val;
  }
  get deleteLoading(): boolean {
    if (this._deleteLoading !== undefined) return this._deleteLoading;
    if (typeof this.config?.deleteLoading === 'function') {
      const data = this.eoForm?.getFormData();
      return this.config.deleteLoading(data);
    }
    return this.config?.deleteLoading === true || false;
  }

  @Output() onSubmit = new EventEmitter<any>();
  @Output() onDeleteItem = new EventEmitter<any>();

  formConfig?: EoFormConfig;
  formDialogVisible = false;

  onFetchData(): void {
    if (!this.config?.fetchApiUrl) return;

    this.formTableService
      .fetch(this.config.fetchApiUrl)
      .subscribe((data) => this.onFetchDataSuccess(data));
  }

  onFetchDataSuccess(data: any[]) {
    if (!this.config) return;
    this.config.tableData = data;
  }

  onCreateButtonClick(): void {
    this.formDialogVisible = true;
  }

  onFormSubmit(formData: any): void {
    const data = this.eoForm?.getFormData();
    this.config?.onSubmit?.(data);
    this.onSubmit.emit(data);
  }

  onCreateNewSuccess(): void {
    this.formDialogVisible = false;
  }

  onDelete(item: any): void {
    this.config?.onDelete?.(item);
    this.onDeleteItem.emit(item);
  }

  onDeleteSuccess(data: any): void {
    // remove data from array
  }

  setFormConfig(): void {
    this.formConfig = new EoFormConfig({
      id: this.config!.formId,
      config: [
        new EoFormPanelConfig({
          name: 'form',
          styleClass: 'grid',
          config: this.getFormControls(this.config!.formFields!),
        }),
      ],
    });

    if (this.eoForm) this.eoForm.config = this.formConfig;
  }

  getFormControls(fields: IFormField[]): IEoFormControlConfig[] {
    let formControls: IEoFormControlConfig[] = [];

    fields.forEach((field) => {
      let fcConfig: IEoFormControlConfig | undefined;
      switch (field.type) {
        case 'dropdown':
          fcConfig = new EoDropdownConfig({
            ...this.getEoFormControlConfig(field),
            optionLabel: field.optionLabel,
            optionValue: field.optionValue,
            apiUrl: field.url,
          });
          break;
        case 'multiselect':
          fcConfig = new EoMultiselectConfig({
            ...this.getEoFormControlConfig(field),
            optionLabel: field.optionLabel,
            optionValue: field.optionValue,
            apiUrl: field.url,
          });
          break;
        case 'dateTo':
          fcConfig = new EoDatepickerConfig({
            ...this.getEoFormControlConfig(field),
            appendTo: 'body',
          });
          break;
        case 'dateFrom':
          fcConfig = new EoDatepickerConfig({
            ...this.getEoFormControlConfig(field),
            appendTo: 'body',
          });
          break;
        case 'date':
          fcConfig = new EoDatepickerConfig({
            ...this.getEoFormControlConfig(field),
            appendTo: 'body',
          });
          break;
        case 'number':
          fcConfig = new EoInputConfig({
            ...this.getEoFormControlConfig(field),
            type: 'number',
          });
          break;
        case 'hidden':
          fcConfig = new EoInputConfig({
            name: field.fieldId,
            styleClass: 'hidden',
            control: new FormControl('-'),
          });
          break;
      }

      if (fcConfig) formControls.push(fcConfig);
    });

    return formControls;
  }

  getEoFormControlConfig(field: IFormField): EoFormControlConfig {
    return {
      name: field.fieldId,
      styleClass: 'col-12',
      label: field.label,
      control: new FormControl(null, [...field.validators]),
    };
  }
}
